import { render, staticRenderFns } from "./TranscriptPrint.vue?vue&type=template&id=3b825bf8&scoped=true"
import script from "./TranscriptPrint.vue?vue&type=script&lang=js"
export * from "./TranscriptPrint.vue?vue&type=script&lang=js"
import style0 from "./TranscriptPrint.vue?vue&type=style&index=0&id=3b825bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b825bf8",
  null
  
)

export default component.exports